import { useEffect, useRef } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { basket, useBasket } from "@/lib/basket";

// Keeps a logged-in user's browser basket mirrored on the server (for reminders and cross-device)
export function BasketSync() {
  const { user } = useAuth();
  const b = useBasket();
  const ready = useRef(null);

  useEffect(() => {
    if (!user) { ready.current = null; return; }
    api.get("/basket").then((r) => {
      ready.current = user.id;
      if (!b.count && (r.data.subs.length || r.data.reports.length)) basket.replace(r.data);
      else if (b.count) api.put("/basket", { subs: b.subs, reports: b.reports }).catch(() => {});
    }).catch(() => { ready.current = user.id; });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  useEffect(() => {
    if (!user || ready.current !== user.id) return;
    const t = setTimeout(() => api.put("/basket", { subs: b.subs, reports: b.reports }).catch(() => {}), 800);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [b.subs, b.reports, user?.id]);
  return null;
}
